import { render, staticRenderFns } from "./WishListOverview.vue?vue&type=template&id=03f04c34&"
import script from "./WishListOverview.vue?vue&type=script&lang=js&"
export * from "./WishListOverview.vue?vue&type=script&lang=js&"
import style0 from "./WishListOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports